export default "__VITE_ASSET__402cec94__"